// Packages
import { Component } from "react";
import { Link } from "react-router-dom";
import { symbol, symbolCircle } from "d3-shape";

// Views
import SuperAdminDashboard from "../superAdmin/superAdminDashboard";
import userService from "../../services/user.service";

// Styles
import "./superAdmin.css";

// material UI
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";

// Assets
import cuttingVdo from "../../assets/images/cuttingVideos.png";
import selfNotes from "../../assets/images/selfNotes.png";
import tagAthlets from "../../assets/images/tagAthlets.png";
import schoolLogo from "../../assets/images/default_school.png";
import videoCamera from "../../assets/images/videoCamera.svg";
import createEventAdmin from "../../assets/images/createEventAdmin.svg";
import intercutAdmin from "../../assets/images/intercutAdmin.svg";
import group from "../../assets/images/groups.png";
import LineGraph from "./Graphs/LineGraph";

import {
  LineSeries,
  ScatterSeries,
} from "@devexpress/dx-react-chart-material-ui";
import { MenuItem, Select } from "@material-ui/core";
import CommonPopup from "../schoolAdminPortal/Popups/CommonPopup";
import moment from "moment";
import { getFromLocalStorage } from "../../utils/webStorage";
import PageNotFoundPage from "../../Common/PageNotFoundPage";

const Point = (type, styles) => (props) => {
  const { arg, val, color } = props;
  return (
    <path
      fill={color}
      transform={`translate(${arg} ${val})`}
      d={symbol()
        .size([10 ** 1.7])
        .type(type)()}
      style={styles}
    />
  );
};

const DiamondPoint = Point(symbolCircle, {
  stroke: "white",
  strokeWidth: "1px",
});
const LineWithDiamondPoint = (props) => (
  <>
    <LineSeries.Path {...props} />
    <ScatterSeries.Path {...props} pointComponent={DiamondPoint} />
  </>
);

window.onclick = function (event) {
  if (!event.target.matches(".dropbtn")) {
    var dropdowns = document.getElementsByClassName("dropdown-content");
    var i;
    for (i = 0; i < dropdowns.length; i++) {
      var openDropdown = dropdowns[i];
      if (openDropdown.classList.contains("show")) {
        openDropdown.classList.remove("show");
      }
    }
  }
};

class DashboardData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      getActiveCount: null,
      getInActiveCount: null,
      getPayPendingCount: null,
      getPayOverdueCount: null,
      getGlobleStorage: null,
      storageFormat: null,
      totalStorage: null,
      totalStorageFormat: null,

      year: new Date().getFullYear(),
      getAllSchoolGraphData: [],
      getAllSchoolGraphDataState: [],
      mostUsedSchools: [],
      mostUsedSchoolFeatures: [],
      visitorsCount: {
        totalVisitors: "",
        visitorsToday: "",
      },
      age: 20,
      customFilter: false,
      loginRole: getFromLocalStorage("loginRole"),
    };
    this.dropdownOpen = this.dropdownOpen.bind(this);
  }

  componentDidMount() {
    const school = document.getElementById("Dashboard");
    if (school) {
      school.classList.add("active");
    }
    this.getSchoolDashboardData();
    this.getSchoolGraphData(this.state.year);
    this.getSchoolDashboardPaymentStausData();
    this.getMostUsedSchools();
    this.getMostUsedSchoolsFeature();
    this.getSchoolGraphDataStateWise(this.state.year);
    this.getStorageCountDashboard();
    this.getWebsiteVisitorsCount(7);
  }

  getWebsiteVisitorsCount = (number) => {
    const { visitorsCount } = this.state;
    const data = userService.getWebsiteVisitorsCount(number);
    data
      .then((res) => {
        this.setState({
          visitorsCount: {
            ...visitorsCount,
            totalVisitors: res.data.data.totalCount,
            visitorsToday: res.data.data.todayCount,
          },
        });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  getWebsiteVisitorsCountByDate = (startDate, endDate) => {
    const { visitorsCount } = this.state;
    const data = userService.getWebsiteVisitorsCountByDate(
      `${moment(startDate).format("YYYY/MM/DD").replaceAll("/", "-")} 14:42`,
      `${moment(endDate).format("YYYY/MM/DD").replaceAll("/", "-")} 14:42`
    );
    data
      .then((res) => {
        this.setState({
          visitorsCount: {
            ...visitorsCount,
            totalVisitors: res.data.data.totalCount,
            visitorsToday: res.data.data.todayCount,
          },
          customFilter: false,
        });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  getSchoolDashboardData() {
    userService.getSuperAdminDashboard().then((res) => {
      var getActiveCount = res.data.data.activeSchoolCount;
      var getInActiveCount = res.data.data.inactiveSchoolCount;
      this.setState({ getActiveCount });
      this.setState({ getInActiveCount });
    });
  }

  getStorageCountDashboard() {
    userService.getStorageCountSADashboard().then((res) => {
      var getGlobleStorage = res.data.data.globleStorage.slice(0, -3);
      var storageFormat = res.data.data.globleStorage.slice(-2);
      var totalStorage = res.data.data.storage.slice(0, -4);
      var totalStorageFormat = res.data.data.storage.slice(-3);

      this.setState({
        getGlobleStorage,
        storageFormat,
        totalStorage,
        totalStorageFormat,
      });
      this.setState({ storageFormat });
    });
  }

  getSchoolDashboardPaymentStausData() {
    userService.getPaymentStausWiseCount().then((res) => {
      var getPayPendingCount = res.data.data.pendingCount;
      var getPayOverdueCount = res.data.data.overdueCount;

      this.setState({ getPayPendingCount });
      this.setState({ getPayOverdueCount });
    });
  }

  getMostUsedSchools() {
    userService.getMostUsedSchool().then((res) => {
      var mostUsedSchools = res.data.data.mostUsedFeaturesDetailsResponses;
      this.setState({ mostUsedSchools });
    });
  }

  getMostUsedSchoolsFeature() {
    userService.getMostUsedSchoolFeature().then((res) => {
      var mostUsedSchoolFeatures =
        res.data.data.mostUsedFeaturesDetailsResponses;
      this.setState({ mostUsedSchoolFeatures });
    });
  }

  getSchoolGraphData(year) {
    userService.getSchoolGraphDetails(year).then((res) => {
      var getAllSchoolGraphData = [];
      var obj = {};
      for (
        let i = 0;
        i < res.data.data.schoolOnboardGraphDataDetailsResponses.length;
        i++
      ) {
        var obj = {};
        obj["month"] =
          res.data.data.schoolOnboardGraphDataDetailsResponses[i].month;
        obj["School Count"] =
          res.data.data.schoolOnboardGraphDataDetailsResponses[
            i
          ].activeSchoolCount;
        getAllSchoolGraphData.push(obj);
      }
      this.setState({ getAllSchoolGraphData });
    });
  }

  getSchoolGraphDataStateWise(year) {
    // const{year}=this.state
    userService.getSchoolGraphDetails(year).then((res) => {
      var getAllSchoolGraphDataState = [];
      var obj = {};
      for (
        let i = 0;
        i < res.data.data.schoolOnboardStateDetailsResponses.length;
        i++
      ) {
        var obj = {};
        obj["stateName"] =
          res.data.data.schoolOnboardStateDetailsResponses[i].stateName;
        obj["School Count"] =
          res.data.data.schoolOnboardStateDetailsResponses[i].activeSchoolCount;
        if (obj["School Count"] > 0) {
          getAllSchoolGraphDataState.push(obj);
        }
      }
      this.setState({ getAllSchoolGraphDataState });
    });
  }

  dropdownOpen() {
    const dropDownList = document.getElementById("myDropdown");
    if (dropDownList) {
      dropDownList.classList.toggle("show");
    }
  }

  handleDropdownChange = (event) => {
    if (event.target.value == 40) {
      this.toggleFilterPopup();
      this.setState({ age: event.target.value });
      return;
    }
    this.getWebsiteVisitorsCount(event.target.value);
    this.setState({ age: event.target.value });
  };

  toggleFilterPopup = () => {
    this.setState({ customFilter: !this.state.customFilter });
  };

  render() {
    const {
      getActiveCount,
      getInActiveCount,
      getAllSchoolGraphData,
      getAllSchoolGraphDataState,
      getPayPendingCount,
      getPayOverdueCount,
      mostUsedSchools,
      mostUsedSchoolFeatures,
      getGlobleStorage,
      storageFormat,
      totalStorage,
      totalStorageFormat,
      visitorsCount,
      customFilter,
      age,
      year,
      loginRole,
    } = this.state;
    return (
      <>
        {loginRole === "SUPER ADMIN" ? (
          <div className="">
            <SuperAdminDashboard />
            <div className="clear10"></div>
            <div className="pad20 content-layout">
              <div>
                <label className="fs-24 bold BLACK">OVERVIEW</label>
              </div>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={3}>
                  <Paper className=" white-card">
                    <label className="semi-bold fs-20">SCHOOLS</label>
                    <hr className="hr-line"></hr>
                    <div>
                      <div className="txtBlue-new fs-60 semi-bold">
                        {getActiveCount ? getActiveCount : 0}
                      </div>
                      <p className="StatusCss bold">Active</p>
                    </div>
                    <div>
                      <div className="txt-lightblue fs-60 semi-bold">
                        {getInActiveCount ? getInActiveCount : 0}
                      </div>
                      <p className="StatusCss semi-bold">In-Active</p>
                    </div>
                    <div className="clear30"></div>
                    <Link to="/schools">
                      <div className="fs-18 link-blue semi-bold">
                        <u>See Details</u>
                      </div>
                    </Link>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Paper className=" white-card">
                    <label className="semi-bold fs-20">PAYMENTS</label>
                    <hr className="hr-line"></hr>
                    <div>
                      <div className="txtBlue-new fs-60 semi-bold">
                        {getPayOverdueCount !== null ? getPayOverdueCount : "0"}
                      </div>
                      <p className="StatusCss semi-bold">Overdue Payment</p>
                    </div>
                    <div>
                      <div className="txt-lightblue fs-60 semi-bold">
                        {getPayPendingCount !== null ? getPayPendingCount : "0"}
                      </div>
                      <p className="StatusCss semi-bold">Pending Payment</p>
                    </div>
                    <div className="clear30"></div>
                    <Link to="/payment">
                      <div className="fs-18 link-blue semi-bold">
                        <u>See Details</u>
                      </div>
                    </Link>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Paper className=" white-card">
                    <label className="semi-bold fs-20">STORAGE</label>
                    <hr className="hr-line"></hr>
                    <div>
                      {totalStorage != null && (
                        <div className="txtBlue-new semi-bold">
                          <span className="fs-60">{totalStorage}</span>
                          <span className="fs-20">{totalStorageFormat}</span>
                        </div>
                      )}
                      {totalStorage == null && (
                        <div className="txtBlue-new semi-bold">
                          <span className="fs-60">0</span>
                          <span className="fs-20">TB</span>
                        </div>
                      )}
                      <p className="StatusCss semi-bold">Total Storage</p>
                    </div>
                    <div>
                      {getGlobleStorage != null && (
                        <div className="txt-lightblue semi-bold">
                          <span className="fs-60">{getGlobleStorage}</span>
                          <span className="fs-20">{storageFormat}s</span>
                        </div>
                      )}
                      {getGlobleStorage == null && (
                        <div className="txt-lightblue semi-bold">
                          <span className="fs-60">0</span>
                          <span className="fs-20">TB</span>
                        </div>
                      )}
                      <p className="StatusCss semi-bold">Utilized Storage</p>
                    </div>
                    <div className="clear30"></div>
                    <Link to="/storage">
                      <div className="fs-18 link-blue semi-bold">
                        <u>See Details</u>
                      </div>
                    </Link>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Paper className=" white-card">
                    <div className="d-flex justify-content-between">
                      <label className="semi-bold fs-20">WEBSITE</label>
                      <Select
                        value={age}
                        onChange={(e) => this.handleDropdownChange(e)}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        defaultValue={20}
                      >
                        <MenuItem value={20}>Last 7 Days</MenuItem>
                        <MenuItem value={30}>Last Month</MenuItem>
                        <MenuItem value={40}>Custom Filter</MenuItem>
                      </Select>
                    </div>
                    <hr className="hr-line"></hr>
                    <div>
                      <div className="txt-blue fs-60 semi-bold">
                        {visitorsCount.totalVisitors
                          ? visitorsCount.totalVisitors
                          : 0}
                      </div>
                      <p className="StatusCss semi-bold">Total Visitors</p>
                    </div>
                    <div>
                      <div className="txt-lightblue fs-60 semi-bold">
                        {visitorsCount.visitorsToday
                          ? visitorsCount.visitorsToday
                          : 0}
                      </div>
                      <p className="StatusCss semi-bold">Visitors Today</p>
                    </div>
                    <div className="clear30"></div>
                    <Link to="/website">
                      <div className="fs-18 link-blue semi-bold">
                        <u>See Details</u>
                      </div>
                    </Link>
                  </Paper>
                </Grid>
              </Grid>
              <CommonPopup
                open={customFilter}
                toggleFilterPopup={this.toggleFilterPopup}
                getWebsiteVisitCount={this.getWebsiteVisitorsCountByDate}
              />
              <div className="clear30"></div>
              <div>
                <Paper>
                  <div className="graph-input p-16 py-4">
                    <div>
                      <div className="clear10"></div>
                      <label className="bold fs-22">
                        School On-boarding by Month
                      </label>
                    </div>
                    <div className="super-chart ">
                      <div className="clear10"></div>
                      <select
                        className="form-control regular bgGrey"
                        onChange={(event) => {
                          this.getSchoolGraphData(event.target.value);
                        }}
                      >
                        <option value={year}>{year}</option>
                        <option value={year - 1}>{year - 1}</option>
                        <option value={year - 2}>{year - 2}</option>
                      </select>
                    </div>
                  </div>
                  <LineGraph
                    seriesData={getAllSchoolGraphData}
                    type="schoolByMonth"
                  />
                </Paper>
              </div>
              <div className="clear30"></div>
              <div>
                <Paper>
                  <div className=" graph-input p-16 py-4">
                    <div>
                      <div className="clear10"></div>
                      <label className="bold fs-22">
                        School on-boarding by State{" "}
                      </label>
                    </div>
                    <div className="super-chart">
                      <div className="clear10"></div>
                      <select
                        className="form-control regular bgGrey"
                        onChange={(event) => {
                          this.getSchoolGraphDataStateWise(event.target.value);
                        }}
                      >
                        <option value={year}>{year}</option>
                        <option value={year - 1}>{year - 1}</option>
                        <option value={year - 2}>{year - 2}</option>
                      </select>
                    </div>
                  </div>
                  <LineGraph
                    seriesData={getAllSchoolGraphDataState}
                    type="schoolByState"
                  />
                </Paper>
              </div>

              <div className="clear30"></div>

              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={6}>
                  <Paper className="white-card">
                    <label className="bold fs-20">
                      Top 5 most active schools
                    </label>
                    <div className="clear20"></div>
                    {mostUsedSchools &&
                      mostUsedSchools.map((item, index) => (
                        <div className="hoverSchool cp">
                          <div className="school-activity-box">
                            <div>
                              <div className="radius50">
                                {item.logoUrl ? (
                                  <img
                                    className="activeschoolImg"
                                    src={item.logoUrl}
                                    alt=""
                                  />
                                ) : (
                                  <img
                                    className="activeschoolImg-dft"
                                    src={schoolLogo}
                                    alt=""
                                  />
                                )}
                              </div>
                            </div>
                            <div className="school-activity">
                              <div>
                                <div className="semi-bold fs-20 ">
                                  <Link
                                    to={`/schoolnamescreen/${item.schoolId}`}
                                    className="text-dark"
                                  >
                                    {item.title}
                                  </Link>
                                </div>
                                <div className="semi-bold fs-14 lightgrey pb-1">
                                  {item.description}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Paper className=" white-card">
                    <label className="bold fs-20">
                      Top 5 most used features
                    </label>
                    <div className="clear20"></div>
                    {mostUsedSchoolFeatures &&
                      mostUsedSchoolFeatures.map((item, index) => (
                        <div className="hoverSchool">
                          <div className="school-feature-box">
                            <div className="align-self tp-feature-img">
                              {item.title == "ATHLETE" && (
                                <img src={tagAthlets} alt="" />
                              )}
                              {item.title == "EVENT" && (
                                <img src={videoCamera} alt="" />
                              )}
                              {item.title == "GROUP" && (
                                <img src={group} alt="" />
                              )}
                              {item.title == "EVENT MEDIA" && (
                                <img src={createEventAdmin} alt="" />
                              )}
                              {item.title == "EDITED EVENT MEDIA" && (
                                <img src={cuttingVdo} alt="" />
                              )}
                              {item.title == "COACH" && (
                                <img src={intercutAdmin} alt="" />
                              )}
                              {item.title == "HIGHLIGHT" && (
                                <img src={selfNotes} alt="" />
                              )}
                            </div>
                            <div className="school-activity">
                              <div>
                                <div className="semi-bold fs-20">
                                  {item.title}
                                </div>
                                <div className="semi-bold fs-14 lightgrey">
                                  {item.description}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </Paper>
                </Grid>
              </Grid>
            </div>
          </div>
        ) : (
          <PageNotFoundPage />
        )}
      </>
    );
  }
}

export default DashboardData;
